module.exports = __webpack_public_path__ + "static/img/blog_5.460360c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/blog/blog_5.jpg
// module id = 168F
// module chunks = 1